// ** React Imports
import { Fragment } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import MediaPost_useInView from "components/user/MediaPosts/MediaPost_useInView";
import LoadingContainer from "components/layout/LoadingContainer";
import Loader, { StyledLoaderWrapperFullWidth } from "components/layout/Loader";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";

// #####################################################

const PostsList = ({ triggerRef }) => {
	const { t } = useTranslation(["pages", "common"]);

	const posts = useSelector((state) => state.mainPagePosts);

	return (
		<>
			{!posts.loading && posts.data?.length === 0 && (
				<CardWrapper>
					<CardBody>
						<LoadingContainer
							empty
							noContentText={t("common:empty.postsList")}
							loaderDefault
						/>
					</CardBody>
				</CardWrapper>
			)}

			{posts.data?.length > 0 &&
				posts.data.map((post) => {
					return (
						<Fragment key={post.id}>
							<MediaPost_useInView item={post} user={post} />
						</Fragment>
					);
				})}

			{posts.loading && (
				<CardWrapper>
					<CardBody>
						<StyledLoaderWrapperFullWidth noMargin>
							<Loader />
						</StyledLoaderWrapperFullWidth>
					</CardBody>
				</CardWrapper>
			)}

			{!posts.loading &&
				!(
					posts?.pagination?.currentpage > 0 &&
					posts?.data?.length === 0
				) && (
					<div
						ref={triggerRef}
						style={{ height: "1px", pointerEvents: "none" }}
					/>
				)}
		</>
	);
};

// #####################################################

export default PostsList;

// #####################################################
